module.exports = __webpack_public_path__ + "img/manufacturing.9be74db6.png";